import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconsModule, ModalModule, UiComponentsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { CmsModule } from '@fcom/cms';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { QualtricsModule } from '@fcom/common/qualtrics/qualtrics.module';

import { CommonBookingComponentsModule } from '../../../common-booking/common-booking.module';
import { BoundSelectionErrorMessageComponent } from './components/bound-selection-error-message/bound-selection-error-message.component';
import { FlightSelectionWarningComponent } from './components/flight-selection-warning/flight-selection-warning.component';
import { BookingFlightComponent } from './components/flight/flight.component';
import { GrandTotalComponent } from './components/grand-total/grand-total.component';
import { TripMessageComponent } from './components/trip-message/trip-message.component';
import { SustainabilityTripMessageComponent } from './components/sustainability/sustainability-trip-message/sustainability-trip-message.component';
import { SustainablityInfoModalComponent } from './components/sustainability/sustainablity-info-modal/sustainablity-info-modal.component';
import { MultiCitySurveyComponent } from './components/multi-city-survey/multi-city-survey.component';

const COMPONENTS = [
  BoundSelectionErrorMessageComponent,
  BookingFlightComponent,
  GrandTotalComponent,
  TripMessageComponent,
  SustainabilityTripMessageComponent,
  SustainablityInfoModalComponent,
  FlightSelectionWarningComponent,
  MultiCitySurveyComponent,
];

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    CommonBookingComponentsModule,
    PipesModule,
    GtmModule,
    CmsModule,
    UiTranslateModule,
    UiComponentsModule,
    IconsModule,
    ModalModule,
    QualtricsModule,
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  providers: [],
})
export class BookingCommonModule {}
